export default "__VITE_ASSET__KcO48t_x__"